/**
 * =============================================================================
 * APPLICATION CONFIGURATION UTILITIES
 * =============================================================================
 * 
 * Centralized access to environment variables and application configuration.
 * Provides type-safe access to configuration values with validation.
 * 
 * =============================================================================
 */

/**
 * Get the current tenant ID from environment variables
 * In a real application, this would typically come from:
 * - User authentication context
 * - Route parameters
 * - User session data
 * 
 * For development, it's configured via VITE_TENANT_ID environment variable
 * 
 * @returns The tenant ID string
 * @throws Error if VITE_TENANT_ID is not configured
 */
export function getTenantId(): string {
  const tenantId = import.meta.env.VITE_TENANT_ID
  
  if (!tenantId) {
    throw new Error(
      'VITE_TENANT_ID environment variable is not configured. ' +
      'Please add it to your .env.local file.'
    )
  }
  
  return tenantId
}

/**
 * Get the API base URL from environment variables
 *
 * @returns The API base URL string
 */
export function getApiBaseUrl(): string {
  return import.meta.env.VITE_API_BASE_URL || 'http://localhost:8787'
}

/**
 * Get the Wallet API base URL from environment variables
 *
 * @returns The Wallet API base URL string
 */
export function getWalletApiBaseUrl(): string {
  return import.meta.env.VITE_WALLET_API_BASE_URL || 'http://localhost:8788'
}
